export default __webpack_public_path__ + "static/coperta-sortiment-e1f62bfa127f7d36298c2fd2e788af90.jpg";